import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {SharedModule} from '@app/shared/shared.module';
import {ToolModule} from '@app/tool/tool.module';

import {
    ServiceTicketsComponent,
    ServiceTicketsTableComponent,
    ServiceTicketDetailsComponent
} from './pages/service-tickets';
import {ServiceTicketTasksComponent} from './pages/service-tickets/components/service-ticket-tasks/service-ticket-tasks.component';
import {TicketActivityDetailsComponent} from './pages/service-tickets/components/ticket-activity-details/ticket-activity-details.component';
import {TicketOnHoldModalComponent} from './pages/service-tickets/components/ticket-on-hold-modal/ticket-on-hold-modal.component';
import { ToolTicketApproveModalComponent } from './pages/service-tickets/components/tool-ticket-approve-modal/tool-ticket-approve-modal/tool-ticket-approve-modal.component';

@NgModule({
    declarations: [
        ServiceTicketsComponent,
        ServiceTicketsTableComponent,
        ServiceTicketDetailsComponent,
        ServiceTicketTasksComponent,
        TicketActivityDetailsComponent,
        TicketOnHoldModalComponent,
        ToolTicketApproveModalComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        ToolModule
    ]
})
export class ServiceOperatorModule {
}
